var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9999 53.107H62.4625C57.4919 53.1039 53.463 49.0781 53.46 44.1074C53.46 39.1368 57.4919 35.111 62.4625 35.1079H75.9999",
    stroke: "#3029D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9939 43.9014H62.9517",
    stroke: "#3029D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.548 15H58.4514C68.1427 15 75.9994 22.8567 75.9994 32.548V56.5478C75.9994 66.2391 68.1427 74.0958 58.4514 74.0958H29.548C19.8567 74.0958 12 66.2391 12 56.5478V32.548C12 22.8567 19.8567 15 29.548 15Z",
    stroke: "#3029D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.167 30.1755H45.2209",
    stroke: "#5975FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletServiceIcon);
export default __webpack_public_path__ + "static/media/WalletServiceIcon.890dfefce94f816141b59cad39793025.svg";
export { ForwardRef as ReactComponent };